export enum ScreenName {
  AllAuction = 'all_auction',
  AuctionSchedule = 'auction_schedule',
  FirstDibs = 'first_dibs',
  SavedSearch = 'saved_search',
  Homepage = 'homepage',
  SellerStorefront = 'seller_storefront',
  ListingDetails = 'listing_detail_page',
  Watchlist = 'my_watchlist',
  // Order pages
  AllOrders = 'all_orders_page',
  OrderDetails = 'order_detail_page',
  Checkout = 'checkout',
  OrderTriage = 'problem_triage_homepage',
  LegacyOrders = 'legacy_orders',
  CreateDispute = 'create_dispute_page',
  // User account pages
  MyAccount = 'my_account',
  MarketplaceEligibility = 'marketplace_eligibility',
  MarketplaceRestrictions = 'marketplace_restrictions',
  MyInterests = 'my_interests',
  AddressBook = 'address_book',
  AddressBookDetails = 'address_book_details',
  NotificationPreferences = 'notification_preferences',
  EmailPreferences = 'email_preferences',
  SmsPreferences = 'sms_preferences',
  PersonalSettings = 'personal_settings',
  BusinessProfile = 'business_profile',
  BusinessInfo = 'business_info',
  BuyingEligibility = 'buying_eligibility',
  MyOffers = 'my_offers',
  MyContracts = 'my_contracts',
  ContractDetails = 'contract_detail_page',
  MyBids = 'my_bids',
  MyDisputes = 'my_disputes',
  DisputeDetails = 'dispute_detail_page',
  PaymentMethods = 'payment_methods_page',
  UserManagement = 'user_management',
  // Error pages
  Error = 'error_page',
  // Unknown/fallback
  Unknown = 'unknown',
}
